module.exports = __webpack_public_path__ + "static/pustkova-fba7981fdf1f63fa9bfb33f8c66c30a3.jpg";